define([
	"dojo/_base/lang",
	"csi",
	"csi/_base/underscore",
	"csi/locale",
	"csi/reflection",
	"csi/store/_base",
	"csi/store/Names",
], function(lang, csi, _, locale, reflection, csiStore, Names) {

	const _stores = {};

	const {
		getClassSetting,
		getNodeClassSetting,
		getNodeSetting,
		getSubtypeName,
		getSubtypeSetting,
	} = reflection;

	return {
		// moved to csi/reflection to reduce circular dependencies
		getClassSetting,
		getNodeClassSetting,
		getNodeSetting,
		getSubtypeName,
		getSubtypeSetting,

		/**
		 * Return true if there is more than one active subtype of the given domain type
		 * @param {C8NodeType} type 
		 * @return {boolean}
		 */
		hasSubtype(type) {
			return !!reflection.getClassConfig(type)?.getSubtypes().some((node) => {
				const settings = reflection.getObject(node.Settings);
				return settings.Active;
			});
		},

		/**
		 * Return store of subtypes for given node type
		 * @param {string} type - node type
		 * @param {(subtypeSettings: C8Node) => boolean} [filterFunc] - optional, if specified, filter the store with this function
		 * @return {Names | undefined}
		 */
		getSubtypeStore(type, filterFunc) {
			if (!_stores[type] || filterFunc) {
				const rc = reflection.getClass(type);

				if (rc?.subtype) {
					const cc = reflection.getClassConfig(type);
					if (cc) {
						const subtypes = cc.getSubtypes();
						const items = csi.transform(subtypes, (node) => {
							// add properties for Names store to settings node
							const settings = reflection.getObject(node.Settings);
							if (settings.Active && (!filterFunc || filterFunc(settings))) {
								return lang.mixin(settings, csiStore.nameObject(node));
							}

							return null;
						}) || [];

						items.unshift(csiStore.nameObject(""));

						const store = new Names({
							data: items,
							typeNode: rc.subtype,
						});

						// cache the store when the defautOption is not specified
						if (!filterFunc) {
							_stores[type] = store;
						} else {
							return store;
						}
					}
				}
			}

			return _stores[type];
		},

		getSubtypeUrlByName: function(/*String*/type, /*String*/name) {
			// summary: return subtype url given domain node type and name of the subtype; this can be useful fo BCs
			// to lookup default values for forms by a given name rather than hard-coding the url
			var store = this.getSubtypeStore(type);
			if (store) {
				var queryObject = csi.objectNew(store.labelProperty, name);
				var item = store.internalQuery(queryObject)[0];
				if (item) {
					return store.getIdentity(item);
				}
			}

			return null;
		}
	};
});